import {useState, useEffect} from 'react';
import BusLayout from "./BusLayout";
import {useNavigate} from 'react-router-dom';
import StrWheel from "../assets/img/str_wheel.png";
import {useNotifyHook} from '../hooks/useNotify';

const BusDetails = ({
    bus,
    pickupPoints,
    dropPoints,
    seats,
    coupons,
    fee,
    isCoupon
}) => {
    if (!bus || !pickupPoints || !dropPoints || !seats) {
        return null;
    }
    const notify = useNotifyHook();
    const navigate = useNavigate();

    const upperDeckLeftSeats = seats.filter(seat => seat.position === 'left' && seat.deck === 'upper');
    const upperDeckRightSeats = seats.filter(seat => seat.position === 'right' && seat.deck === 'upper');
    const lowerDeckLeftSeats = seats.filter(seat => seat.position === 'left' && seat.deck === 'lower');
    const lowerDeckRightSeats = seats.filter(seat => seat.position === 'right' && seat.deck === 'lower');

    // State for tabs and selected points
    const [activeTab, setActiveTab] = useState('pickup');
    const [selectedPickup, setSelectedPickup] = useState(null);
    const [selectedDrop, setSelectedDrop] = useState(null);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [totalFare, setTotalFare] = useState(0);

    const [mobileActiveDeck, setMobileActiveDeck] = useState('lower');

    const handleSeatSelect = (seatId, isSelected, seatData) => {
        if (isSelected) {
            setSelectedSeats(prev => [
                ...prev,
                seatData
            ]);
        } else {
            setSelectedSeats(prev => prev.filter(seat => seat.id !== seatId));
        }
    };

    const calculateTotalFare = () => {
        let baseFare = 0;
        selectedSeats.forEach(seat => {
            if (seat.fare && !isNaN(parseFloat(seat.fare))) {
                baseFare += parseFloat(seat.fare);
            }
        });
        setTotalFare(baseFare);
    };

    useEffect(() => {
        calculateTotalFare();
    }, [selectedSeats, selectedPickup, selectedDrop]);

    const updatedSeatsWithHandler = (seatArray) => {
        return seatArray.map(seat => ({
            ...seat,
            onSelect: handleSeatSelect,
            isSelected: selectedSeats.some(s => s.id === seat.id)
        }));
    };

    const handlePickupSelect = (point) => {
        setSelectedPickup(point);
    };

    const handleDropSelect = (point) => {
        setSelectedDrop(point);
    };

    const handleProcessBooking = () => {
        if (!selectedPickup || !selectedDrop) {
            notify.warning('Please select both pickup and drop points');
            return;
        }
        if (selectedSeats.length === 0) {
            notify.warning('Please select at least one seat');
            return;
        }

        const bookingData = {
            bus: {
                id: bus.id,
                name: bus.name,
                type: bus.type,
                deck: bus.deck,
                vendor_id: bus.vendor_id,
                streeing_wheel: bus.streeing_wheel
            },
            pickupPoint: {
                id: selectedPickup.id,
                name: selectedPickup.name,
                time: selectedPickup.time,
                address: selectedPickup.address,
                surcharge: selectedPickup.surcharge
            },
            dropPoint: {
                id: selectedDrop.id,
                name: selectedDrop.name,
                time: selectedDrop.time,
                address: selectedDrop.address,
                surcharge: selectedDrop.surcharge
            },
            seats: selectedSeats.map(seat => ({
                id: seat.id,
                seat_number: seat.seat_number,
                fare: seat.fare,
                deck: seat.deck,
                position: seat.position,
                row: seat.row,
                column: seat.column,
                is_booked: seat.is_booked
            })),
            totalFare: totalFare,
            fee: fee,
            coupons: coupons,
            isCoupon: isCoupon,
            seatCount: selectedSeats.length,
            selectedSeatNumbers: selectedSeats.map(seat => seat.seat_number)
        };

        localStorage.setItem('currentBooking', JSON.stringify(bookingData));

        navigate('/booking/process', {
            state: {
                bookingData: bookingData
            }
        });
    };

    return (
        <>
            <div className="w-full md:hidden mt-1">
                {
                bus.deck === "double" ? (
                    <div className="mb-4">
                        <div className="flex border-b border-gray-300">
                            <button onClick={
                                    () => setMobileActiveDeck('lower')
                                }
                                className={
                                    `flex-1 py-3 text-center font-medium transition-colors ${
                                        mobileActiveDeck === 'lower' ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:bg-gray-50'
                                    }`
                            }>
                                Lower Deck
                            </button>
                            <button onClick={
                                    () => setMobileActiveDeck('upper')
                                }
                                className={
                                    `flex-1 py-3 text-center font-medium transition-colors ${
                                        mobileActiveDeck === 'upper' ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:bg-gray-50'
                                    }`
                            }>
                                Upper Deck
                            </button>
                        </div>
                    </div>
                ) : null
            } </div>
            <div className="grid grid-cols-3 gap-3 mt-1">
                <div className="col-span-3 md:col-span-2 flex justify-center items-start">
                    <div className="flex gap-5">
                        <div className="hidden md:flex gap-5">
                            <div className="lower bg-gray-100 flex-1 w-[max-content] border border-gray-500 rounded p-1">
                                <div className="px-3 pt-2 mb-5 flex items-center justify-between">
                                    <span className={
                                        `text-gray-500 font-semibold ${
                                            bus.streeing_wheel == "right" ? 'order-1' : 'order-2'
                                        }`
                                    }>Lower</span>
                                    <div className={
                                        `${
                                            bus.streeing_wheel == "right" ? 'order-1' : 'order-2'
                                        }`
                                    }>
                                        <img src={StrWheel}
                                            className="h-[30px] w-[30px]"
                                            alt="Steering Wheel"/>
                                    </div>
                                </div>
                                <BusLayout rwType={
                                        bus.row_data.rows_lower
                                    }
                                    seatLeft={
                                        updatedSeatsWithHandler(lowerDeckLeftSeats)
                                    }
                                    seatRight={
                                        updatedSeatsWithHandler(lowerDeckRightSeats)
                                    }/>
                            </div>

                            {
                            bus.deck === "double" && (
                                <div className="upper bg-gray-100 flex-1 w-[250px] border border-gray-500 rounded p-1">
                                    <div className="px-3 pt-2 mb-5 flex items-center justify-between">
                                        <span className="text-gray-500 font-semibold">Upper</span>
                                        <></>
                                    </div>
                                    <BusLayout rwType={
                                            bus.row_data.rows_upper
                                        }
                                        seatLeft={
                                            updatedSeatsWithHandler(upperDeckLeftSeats)
                                        }
                                        seatRight={
                                            updatedSeatsWithHandler(upperDeckRightSeats)
                                        }/>
                                </div>
                            )
                        } </div>

                        {/* Mobile View - Single deck at a time */}
                        <div className="md:hidden w-full">
                            {
                            (mobileActiveDeck === 'lower' || bus.deck !== "double") && (
                                <div className="lower bg-gray-100 w-full border border-gray-500 rounded p-1">
                                    <div className="px-3 pt-2 mb-5 flex items-center justify-between">
                                        <span className={
                                            `text-gray-500 font-semibold ${
                                                bus.streeing_wheel == "right" ? 'order-1' : 'order-2'
                                            }`
                                        }>Lower Deck</span>
                                        <div className={
                                            `${
                                                bus.streeing_wheel == "right" ? 'order-1' : 'order-2'
                                            }`
                                        }>
                                            <img src={StrWheel}
                                                className="h-[30px] w-[30px]"
                                                alt="Steering Wheel"/>
                                        </div>
                                    </div>
                                    <BusLayout rwType={
                                            bus.row_data.rows_lower
                                        }
                                        seatLeft={
                                            updatedSeatsWithHandler(lowerDeckLeftSeats)
                                        }
                                        seatRight={
                                            updatedSeatsWithHandler(lowerDeckRightSeats)
                                        }/>
                                </div>
                            )
                        }

                            {
                            bus.deck === "double" && mobileActiveDeck === 'upper' && (
                                <div className="upper bg-gray-100 w-full border border-gray-500 rounded p-1">
                                    <div className="px-3 pt-2 mb-5 flex items-center justify-between">
                                        <span className="text-gray-500 font-semibold">Upper Deck</span>
                                        <></>
                                    </div>
                                    <BusLayout rwType={
                                            bus.row_data.rows_upper
                                        }
                                        seatLeft={
                                            updatedSeatsWithHandler(upperDeckLeftSeats)
                                        }
                                        seatRight={
                                            updatedSeatsWithHandler(upperDeckRightSeats)
                                        }/>
                                </div>
                            )
                        } </div>
                    </div>
                </div>

                {/* Points Selection Panel with Tabs */}
                <div className="col-span-3 md:col-span-1">
                    <div className="border border-gray-400 rounded-lg bg-white shadow-lg overflow-hidden">
                        <div className="flex border-b border-gray-300">
                            <button onClick={
                                    () => setActiveTab('pickup')
                                }
                                className={
                                    `flex-1 py-3 text-center font-medium transition-colors ${
                                        activeTab === 'pickup' ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:bg-gray-50'
                                    }`
                            }>
                                Pickup Points
                            </button>
                            <button onClick={
                                    () => setActiveTab('drop')
                                }
                                className={
                                    `flex-1 py-3 text-center font-medium transition-colors ${
                                        activeTab === 'drop' ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:bg-gray-50'
                                    }`
                            }>
                                Drop Points
                            </button>
                        </div>

                        {/* Tabs Content */}
                        <div className="p-4">
                            {/* Pickup Points Tab */}
                            {
                            activeTab === 'pickup' && (
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center mb-4 p-2 bg-blue-50 rounded">
                                        <span className="text-sm text-blue-700 font-medium">
                                            Selected Pickup:
                                        </span>
                                        <span className="text-sm font-semibold text-blue-800">
                                            {
                                            selectedPickup ? selectedPickup.name : 'Not selected'
                                        } </span>
                                    </div>

                                    <div className="max-h-60 overflow-y-auto space-y-2">
                                        {
                                        pickupPoints.map((point, index) => (
                                            <div key={
                                                    point.id || index
                                                }
                                                onClick={
                                                    () => handlePickupSelect(point)
                                                }
                                                className={
                                                    `p-3 rounded-lg border cursor-pointer transition-all hover:shadow-md ${
                                                        selectedPickup ?. id === point.id ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-300'
                                                    }`
                                            }>
                                                <div className="flex justify-between items-center">
                                                    <div className="flex items-center space-x-3">
                                                        <div className={
                                                            `w-3 h-3 rounded-full ${
                                                                selectedPickup ?. id === point.id ? 'bg-blue-500' : 'bg-gray-400'
                                                            }`
                                                        }></div>
                                                        <div>
                                                            <div className="font-medium text-gray-800">
                                                                {
                                                                point.name
                                                            }</div>
                                                            {
                                                            point.time && (
                                                                <div className="text-sm text-gray-600">
                                                                    Time: {
                                                                    point.time
                                                                } </div>
                                                            )
                                                        } </div>
                                                    </div>
                                                    {
                                                    point.surcharge && (
                                                        <div className="text-sm font-semibold text-green-600">
                                                            +₹{
                                                            point.surcharge
                                                        } </div>
                                                    )
                                                } </div>
                                                {
                                                point.address && (
                                                    <div className="mt-2 text-xs text-gray-500 pl-6">
                                                        {
                                                        point.address
                                                    } </div>
                                                )
                                            } </div>
                                        ))
                                    } </div>
                                </div>
                            )
                        }

                            {/* Drop Points Tab */}
                            {
                            activeTab === 'drop' && (
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center mb-4 p-2 bg-green-50 rounded">
                                        <span className="text-sm text-green-700 font-medium">
                                            Selected Drop:
                                        </span>
                                        <span className="text-sm font-semibold text-green-800">
                                            {
                                            selectedDrop ? selectedDrop.name : 'Not selected'
                                        } </span>
                                    </div>

                                    <div className="max-h-60 overflow-y-auto space-y-2">
                                        {
                                        dropPoints.map((point, index) => (
                                            <div key={
                                                    point.id || index
                                                }
                                                onClick={
                                                    () => handleDropSelect(point)
                                                }
                                                className={
                                                    `p-3 rounded-lg border cursor-pointer transition-all hover:shadow-md ${
                                                        selectedDrop ?. id === point.id ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-green-300'
                                                    }`
                                            }>
                                                <div className="flex justify-between items-center">
                                                    <div className="flex items-center space-x-3">
                                                        <div className={
                                                            `w-3 h-3 rounded-full ${
                                                                selectedDrop ?. id === point.id ? 'bg-green-500' : 'bg-gray-400'
                                                            }`
                                                        }></div>
                                                        <div>
                                                            <div className="font-medium text-gray-800">
                                                                {
                                                                point.name
                                                            }</div>
                                                            {
                                                            point.time && (
                                                                <div className="text-sm text-gray-600">
                                                                    Time: {
                                                                    point.time
                                                                } </div>
                                                            )
                                                        } </div>
                                                    </div>
                                                    {
                                                    point.surcharge && (
                                                        <div className="text-sm font-semibold text-green-600">
                                                            +₹{
                                                            point.surcharge
                                                        } </div>
                                                    )
                                                } </div>
                                                {
                                                point.address && (
                                                    <div className="mt-2 text-xs text-gray-500 pl-6">
                                                        {
                                                        point.address
                                                    } </div>
                                                )
                                            } </div>
                                        ))
                                    } </div>
                                </div>
                            )
                        } </div>

                        {/* Summary and Booking Button */}
                        <div className="border-t border-gray-300 p-4 bg-gray-50 ">
                            {/* Selected Seats Summary */}
                            <div className="mb-3 ">
                                <div className="flex justify-between items-center mb-2">
                                    <span className="text-gray-700 font-medium">Selected Seats:</span>
                                    <span className="text-sm font-semibold text-blue-600">
                                        {
                                        selectedSeats.length
                                    }
                                        seat{
                                        selectedSeats.length !== 1 ? 's' : ''
                                    } </span>
                                </div>

                                {
                                selectedSeats.length > 0 && (
                                    <div className="mb-3 p-2 bg-white rounded border overflow-y-auto max-h-[100px]">
                                        <div className="text-sm text-gray-600 mb-1">Seat Numbers:</div>
                                        <div className="flex flex-wrap gap-2">
                                            {
                                            selectedSeats.map((seat, index) => (
                                                <div key={index}
                                                    className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                                                    {
                                                    seat.seat_number
                                                }
                                                    (₹{
                                                    seat.fare || 0
                                                })
                                                </div>
                                            ))
                                        } </div>
                                    </div>
                                )
                            }


                                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                                    <div>
                                        <span className="text-lg font-bold text-gray-800">Total Fare:</span>
                                        {
                                        selectedSeats.length > 0 && (
                                            <div className="text-xs text-gray-500">
                                                {
                                                selectedSeats.length
                                            }
                                                seat{
                                                selectedSeats.length !== 1 ? 's' : ''
                                            } </div>
                                        )
                                    } </div>
                                    <span className="text-2xl font-bold text-green-600">₹{totalFare}</span>
                                </div>
                            </div>

                            <button onClick={handleProcessBooking}
                                disabled={
                                    !selectedPickup || !selectedDrop || selectedSeats.length === 0
                                }
                                className={
                                    `w-full py-3 rounded-lg font-semibold text-white transition-colors ${
                                        selectedPickup && selectedDrop && selectedSeats.length > 0 ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800' : 'bg-gray-400 cursor-not-allowed'
                                    }`
                            }>
                                {
                                selectedPickup && selectedDrop && selectedSeats.length > 0 ? `Proceed to Booking (₹${totalFare})` : selectedSeats.length === 0 ? 'Select Seats' : 'Select Pickup & Drop Points'
                            } </button>

                            <div className="mt-3 text-xs text-gray-500 text-center">
                                {
                                selectedSeats.length === 0 ? 'Select seats, pickup and drop points to proceed' : !selectedPickup || !selectedDrop ? 'Select both pickup and drop points to proceed' : 'Click to proceed with booking'
                            } </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BusDetails;
